import Divider from 'components/containers/divider';
import ToolTip from 'components/tooltip';
import styles from './search-tool-tip.module.scss';
import { Link } from 'src/navigation';
import Info from 'assets/icons/info.svg';
import { trackCollectionSearchTipsOpened } from 'lib/analytics/trackSearch';

interface SearchToolTipProps {
	searchQuerystring: string;
}

const SearchToolTip = ({ searchQuerystring }: SearchToolTipProps) => {
	const handleOpenOrClose = (isOpen: boolean) => {
		if (isOpen) {
			trackCollectionSearchTipsOpened({ searchQuerystring });
		}
	};

	return (
		<ToolTip
			id="searchTips"
			onOpenOrClose={handleOpenOrClose}
			jsxDescription={
				<div className={styles.wrapper}>
					<div className={styles.title}>Getting the most out of search</div>
					<ul className={styles.list}>
						<li>
							Search by subject, topic, title, artist, date, culture, material,
							object type, geography, department, gallery, object number or
							credit line.
						</li>
						<li>Wrap your search in quotes to force exact phrase matching.</li>
						<li>
							Use the any/all in some filters to control how multiple filters
							interact.
						</li>
						<li>
							Need inspiration? Browse our list of{' '}
							<Link href="/art/collection">suggested searches</Link>.
						</li>
					</ul>
					<Divider margin="var(--spacing-micro)" />
					<div>
						Read more about{' '}
						<Link href="/perspectives/introducing-semantic-search-at-the-met">
							our approach to search
						</Link>{' '}
						or{' '}
						<Link
							href={
								'https://airtable.com/appmOhFn8vkAvLXIl/pagWHHTN4yMgI0ISp/form'
							}
						>
							leave us feedback
						</Link>
					</div>
				</div>
			}
		>
			<span className={styles.trigger}>
				Search Tips <Info />
			</span>
		</ToolTip>
	);
};

export default SearchToolTip;
